import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';

const CountdownTimer = ({ expiryTimestamp }) => {
  const calculateTimeLeft = useCallback(() => {
    const targetTime = moment.utc(expiryTimestamp);
    const now = moment.utc();
    let timeLeft = { hours: 0, minutes: 0, seconds: 0 };
    if (targetTime.isValid() && targetTime.isAfter(now)) {
      const duration = moment.duration(targetTime.diff(now));
      timeLeft = {
        hours: Math.floor(duration.asHours()),
        minutes: duration.minutes(),
        seconds: duration.seconds()
      };
    }
    return timeLeft;
  }, [expiryTimestamp]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [calculateTimeLeft, expiryTimestamp]);

  const padZero = (num) => num.toString().padStart(2, '0');

  return (
    <div className="flex items-center gap-2 bg-[#E0C7A7] rounded-md px-4 py-1 text-[#040F46] font-black text-xl tabular-nums">
      <span>{padZero(timeLeft.hours)}</span>
      <span>:</span>
      <span>{padZero(timeLeft.minutes)}</span>
      <span>:</span>
      <span>{padZero(timeLeft.seconds)}</span>
    </div>
  );
};

export default CountdownTimer;
